<template>
    <router-link to="blogs/1" class="coursesCard -type-1 pb-10 border-light bg-white rounded-8 mb-3" data-aos="fade-up"
        :data-aos-delay="200">
        <div class="relative">
            <div class="coursesCard__image overflow-hidden rounded-8">
                <img class="w-1/1" src="../../assets/images/home/course-1.png" alt="image" />
            </div>
            <div class="d-flex justify-between py-10 px-10 absolute-full-center z-3"></div>
        </div>

        <div class="px-10 pt-10 d-flex flex-column gap-2 courseCard-body">
            <h3 class="fw-700 text-dark-1 mt-15 capitalize">
                Interactive Dashboards Using Power BI erererer eeeeeeeee
            </h3>

            <p class="exprience fw-500">
                More than 8yr Experience as primavera. Learn how to becoming
                professional Now.
            </p>

            <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
                <span class="d-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path
                            d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                            stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                        <path
                            d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                            stroke="#94AD04" stroke-width="1.5" />
                    </svg>
                </span>
                <span class="fw-500 d-inline-block pt-1"> Ali Katary </span>
            </div>

            <p class="puplish-date fw-600">
                Jan 22, 2024
            </p>
        </div>
    </router-link>
</template>